/**
 * @generated SignedSource<<000e1d499ffbe76189248105001af591>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanySelect_organization$data = {
  readonly companies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "CompanySelect_organization";
};
export type CompanySelect_organization$key = {
  readonly " $data"?: CompanySelect_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanySelect_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "companies"
        ]
      }
    ]
  },
  "name": "CompanySelect_organization",
  "selections": [
    {
      "alias": "companies",
      "args": [
        {
          "kind": "Literal",
          "name": "includeDeleted",
          "value": "NO"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "NAME_ASC"
        }
      ],
      "concreteType": "CompaniesConnection",
      "kind": "LinkedField",
      "name": "__CompanySelect_companies_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompaniesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Company",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__CompanySelect_companies_connection(includeDeleted:\"NO\",orderBy:\"NAME_ASC\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "6ab6c2a3d3734470fea049c698c4d490";

export default node;
